export const isWordFile = (url) => /\.docx?(?:[?#]|$)/i.test(String(url || ''));

// Stored URLs and explicit downloads keep their original route. Browser previews
// use API-streamed bytes so PDF.js does not depend on the GCS bucket's CORS policy.
// Legacy Word uploads retain their original; the preview route supplies a cached PDF.
export const filePreviewUrl = (url) => {
  if (typeof url !== 'string') return url;
  const path = url.split(/[?#]/, 1)[0];
  if (!/\/files\/handwritten\/[^/]+$/i.test(path) ||
      !/\.(?:docx?|pdf|png|jpe?g|webp|gif|avif|bmp)$/i.test(path)) return url;
  return url.replace('/files/handwritten/', '/files/preview/handwritten/');
};

export const canPreviewWord = (url) => /\.docx(?:[?#]|$)/i.test(String(url || '')) &&
  String(url || '').includes('/files/preview/handwritten/');
